/*
 * File: src/routes/create-account/Welcome.tsx
 * Notes:
 *   > ...
 */

import React, { VoidFunctionComponent } from "react";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useTextHighlightStyles from "../../../styles/useTextHighlightStyles";
import { useHistory } from "react-router-dom";
import { Link } from "@material-ui/core";
import { CUSTOMER_SERVICE_NUMBER } from "../../../constants/strings";

const useStyles = makeStyles((theme) => ({
  container: {
    "& > *:not(:last-child)": {
      marginBottom: theme.spacing(4),
    },
  },
}));

const WelcomeHasCard: VoidFunctionComponent = () => {
  const classes = useStyles();
  const textClasses = useTextHighlightStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h4" className={textClasses.textHighlightGreen}>
        You Are Almost Ready to CLYNK!
      </Typography>

      <Typography>
        Thank you for signing up for your CLYNK account at{" "}
        <Link href="https://clynk.com">clynk.com</Link>.
        <br />
        <br />
        You will receive your Welcome Kit in 5 to 7 days. It includes an
        introduction to CLYNK’s program, 10 personalized, barcoded bag tags, and
        a voucher for a free box of bags. If you don’t want to wait for your
        personalize bag tags, please visit your nearest Hannaford location and
        use your CLYNK membership card and 4-digit PIN to access the kiosk and
        print tags. You are now part of a large and growing group of people who
        want to recycle and redeem the clean and convenient way. We are glad you
        are here.
        <br />
        <br />
        If you need help signing up or have any questions, please call our
        amazing Customer Support team at {CUSTOMER_SERVICE_NUMBER} between 9am
        and 5pm, Monday through Friday. We are glad you are here!
      </Typography>
    </div>
  );
};

const WelcomeNoCard: VoidFunctionComponent = () => {
  const classes = useStyles();
  const textClasses = useTextHighlightStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h4" className={textClasses.textHighlightGreen}>
        Your Welcome Kit is on its way!
      </Typography>

      <Typography>
        Thank you for signing up for your CLYNK account at{" "}
        <Link href="https://clynk.com">clynk.com</Link>. You have received an
        email with an activation link. Once you’ve completed that step, you will
        have all the credentials you need to access your account online
        (username and password) and at the kiosk (4 digit PIN). If you can’t
        find our email, check your spam folder.
        <br />
        <br />
        In the next 5 to 7 days, you will receive your Welcome Kit. It includes
        an introduction to CLYNK’s program, your unique membership card + 2 key
        fobs, 10 personalized barcoded bag tags, and a voucher for a free box of
        bags. You are now part of a large and growing group of people who want
        to recycle and redeem the clean and convenient way.
        <br />
        <br />
        If you need help signing up or have any questions, please call our
        amazing Customer Support team at {CUSTOMER_SERVICE_NUMBER} between 9am
        and 5pm, Monday through Friday. We are glad you are here!
      </Typography>
    </div>
  );
};

const Welcome: VoidFunctionComponent = () => {
  const history = useHistory();

  const hasCard = history.location.state?.card !== undefined;

  return hasCard ? <WelcomeHasCard /> : <WelcomeNoCard />;
};

export default Welcome;
